import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import Constraint from 'js/components/Constraint';
import Modal from 'js/components/core/Modal';

import Title from 'js/components/core/SteppedPage/Title';
import SubTitle from 'js/components/core/SteppedPage/SubTitle';
import StepStatus from 'js/components/core/SteppedPage/StepStatus';
import ProgressRow from 'js/components/core/SteppedPage/ProgressRow';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import SkipButton from 'js/components/core/SteppedPage/SkipButton';
import Backdrop from 'js/components/core/Backdrop';
import AddButton, { buttonHeight } from 'js/components/core/SteppedPage/AddButton';
import ChoicesForm from "js/components/pages/MyAccountPage/ReceivingAccount/ChoicesForm";

import Form from './Form';
import Display from './Display';

import { bankAccountHeight } from 'js/components/core/BankAccountDisplay';
import CreditCardDisplay from "js/components/core/CreditCardDisplay";
import ReceivingAccountStore from "js/stores/pages/MyAccountPageState/ReceivingAccount";

@inject('page')
@observer
export default class ReceivingAccount extends Component {
  render() {
    const page = this.props.page;
    const showDisplayBankAccount = page.bankAccount.isFilledIn;
    const showDisplayDebitAccount = !!page.debitCard.number;
    const contentOffset = showDisplayBankAccount ? `${bankAccountHeight / 2}rem` : `${buttonHeight / 2}rem`;

    return (
      <>
        <Backdrop offset={contentOffset}>
          <Constraint>
            <Title>Receiving account</Title>
            <SubTitle>Connect a bank account where you'd like your payment to be deposited.</SubTitle>
          </Constraint>
        </Backdrop>

        <Constraint offset={contentOffset}>
          {showDisplayBankAccount || showDisplayDebitAccount ? (
              <>
                {showDisplayBankAccount ? (<><Display /><br/></>):(<></>)}
                {showDisplayDebitAccount ? (<><CreditCardDisplay creditCard={page.debitCard} onEdit={page.showChoicesModal} /><br/></>):(<></>)}
              </>
          ) : (
           <>
           </>
          )}
          <AddButton autoFocus onClick={page.showChoicesModal} isLoading={page.isBusy} noIcon={page.isBusy}>
            {page.plaidIsStarted
              ? 'Please wait...'
              : page.savingPlaidItem
                ? 'Registering account...'
                : 'Add a receiving account'}
          </AddButton>
          <ProgressRow>
            <ContinueButton autoFocus={showDisplayBankAccount} onClick={page.nextStep} disabled={!(showDisplayBankAccount || showDisplayDebitAccount)}>
              Continue
            </ContinueButton>
            {!showDisplayBankAccount && <SkipButton onClick={page.nextStep}>Skip, I'll do this later</SkipButton>}
            <StepStatus />
          </ProgressRow>
        </Constraint>

        <Modal showModal={page.modalIsVisible} onCancel={page.closeModals} withCloseButton>
          <Form />
        </Modal>

        <Modal showModal={page.choicesModalIsVisible} onCancel={page.closeModals} withCloseButton>
          <ChoicesForm state={page} />
        </Modal>
      </>
    );
  }
}
